<template>
  <section>
    <TheArticleList
      :articles="feature.data.artworks"
      linkPath="artwork"
      displayType="card"
    >
      <TheListTitle :listTitle="articleTitle" prefix="feature" />
      <section class="feature-filter">
        <HomepageFeatures
          :features="homeFeatures"
          :featureId="$route.params.featureId"
        />
      </section>
    </TheArticleList>
    <!-- <TheListPagination
      category="feature"
      :pages="feature"
      @update:getUpdatedArticles="$store.dispatch('getUpdatedArticles', $event)"
    />-->
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';
// import { lazyloading } from '@/utils/lazyloading';

import TheListTitle from '@/components/list/TheListTitle';
import HomepageFeatures from '@/components/HomepageFeatures';
import TheArticleList from '@/components/list/TheArticleList';
// import TheListPagination from '@/components/list/TheListPagination';

export default {
  name: 'FeatureResults',
  data() {
    return {};
  },
  metaInfo() {
    return {
      title: '分類詳細資訊',
    };
  },
  computed: {
    feature() {
      return this.$store.getters.feature;
    },
    articleTitle() {
      return getArticleString('feature', 'headline');
    },
    homeFeatures() {
      return this.$store.getters.homeFeatures;
    },
    featureId() {
      return this.$route.params.featureId;
    },
  },
  async mounted() {
    await this.getHomeFeatures();
    await this.getFeature();
    // await lazyloading();
  },
  methods: {
    async getFeature() {
      try {
        await this.$store.dispatch('getFeature', this.featureId);
      } catch (e) {
        console.error(e);
      }
    },
    async getHomeFeatures() {
      // 載入藝品列表頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch('getHomeFeatures');
      } catch (e) {
        console.error(e);
      }
    },
  },
  watch: {
    featureId(value, oldValue) {
      if (value !== oldValue) {
        this.getFeature();
      }
    },
  },
  components: {
    TheListTitle,
    HomepageFeatures,
    TheArticleList,
    // TheListPagination,
  },
};
</script>

<style lang="scss" scoped>
.feature-filter {
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
